import type { MarketVariants } from '@/lib/i18n'

export type Slide2MargaretCopy = {
  /** Body sentence split around the bolded "Pause, then Verify." emphasis. */
  bodyBefore: string
  bodyEmphasis: string
}

export const copy: MarketVariants<Slide2MargaretCopy> = {
  US: {
    bodyBefore:
      "Whether it's fake family emergencies or bank fraud alerts, there's one simple strategy that can stop a scam in its tracks: ",
    bodyEmphasis: 'Pause, then Verify.',
  },
  ar: {
    bodyBefore:
      'سواء كانت حالة طارئة عائلية مزيّفة أو تنبيهاً مزعوماً عن احتيال مصرفي، هناك أسلوب بسيط واحد يمكنه إيقاف الاحتيال في مساره: ',
    bodyEmphasis: 'توقّف، ثم تحقّق.',
  },
}
